import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDM6p2Sug1CGkyHgFBIvwFqciLP16BPmw0",
    authDomain: "chatterbox-cd26a.firebaseapp.com",
    projectId: "chatterbox-cd26a",
    storageBucket: "chatterbox-cd26a.appspot.com",
    messagingSenderId: "736639463145",
    appId: "1:736639463145:web:09e7b71e74f5381e944a78",
    measurementId: "G-79BYCRXK88"
  };

firebase.initializeApp(firebaseConfig);

export const provider = new firebase.auth.GoogleAuthProvider();

export const auth = firebase.auth();
export const firestore = firebase.firestore();

firebase.firestore().enablePersistence();

export const generateUserDocument = async (user, additionalData) => {
    if(!user) return;
    console.log(additionalData, "additional data");
    const userRef = firestore.doc(`users/${user.uid}`);
    console.log(user, "was here");
    const snapshot = await userRef.get(); 
    if(!snapshot.exists){
        console.log("was here also")
        const {email} = user;
        try{
            await userRef.set({
                email,
                ...additionalData
            });
        }catch(error){
            console.error("Error creating user document", error);
        }
    }
    return getUserDocument(user.uid);
}

const getUserDocument = async uid => {
    if(!uid) return null;
    try{
        const userDocument = await firestore.doc(`users/${uid}`).get();
        return {
            uid,
            ...userDocument.data()
        }
    }catch(error){
        console.error("Error fetching user", error);
    }
}